import React, { useEffect, useState } from "react";
import { Draggable, Droppable, DragDropContext } from "@hello-pangea/dnd";
import { Box, Container, Typography, Button, Paper, Grid } from "@mui/material";
import Stack from "@mui/material/Stack";
import AudioPlayer from "../../AudioPlayer";
import { API_DOMAIN } from "../../../constants";
//const API_DOMAIN = "https://capacitamos.com/online"

const DraggableItem = ({ id, content, index }) => (
  <Draggable draggableId={id} index={index}>
    {(provided) => (
      <Paper
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        sx={{
          padding: 1,
          textAlign: "center",
          minWidth: 80,
          cursor: "pointer",
        }}
      >
        {content}
      </Paper>
    )}
  </Draggable>
);

const DroppableZone = ({ id, items }) => (
  <Droppable droppableId={id} direction="horizontal">
    {(provided) => (
      <Box
        ref={provided.innerRef}
        {...provided.droppableProps}
        sx={{
          display: "flex",
          //justifyContent: "center",
          alignItems: "center",
          flexWrap: "nowrap",
          border: "1px dashed gray",
          padding: 2,
          height: 100,
          overflow: 'auto'
        }}
      >
        {items.map((item, index) => (
          <DraggableItem
            key={item.id}
            id={item.id}
            content={item.content}
            index={index}
          />
        ))}
        {provided.placeholder}
      </Box>
    )}
  </Droppable>
);

const DragAndDropSentence = ({ question, showInCorrect, setAnswer, courseCode }) => {

  const initialWords = question.frase
    .split(" ")
    .concat(question.palabra_error.split(" "))
    .sort(() => Math.random() - 0.5);
  const [words, setWords] = useState(
    initialWords.map((word, index) => ({ id: `word-${index}`, content: word }))
  );
  const [orderedWords, setOrderedWords] = useState([]);

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const sourceIndex = result.source.index;
    const destinationIndex = result.destination.index;

    if (result.source.droppableId === result.destination.droppableId) {
      const items = Array.from(
        result.source.droppableId === "words" ? words : orderedWords
      );
      const [movedItem] = items.splice(sourceIndex, 1);
      items.splice(destinationIndex, 0, movedItem);

      if (result.source.droppableId === "words") {
        setWords(items);
      } else {
        setOrderedWords(items);
      }
    } else {
      const sourceItems = Array.from(
        result.source.droppableId === "words" ? words : orderedWords
      );
      const destinationItems = Array.from(
        result.source.droppableId === "words" ? orderedWords : words
      );
      const [movedItem] = sourceItems.splice(sourceIndex, 1);
      destinationItems.splice(destinationIndex, 0, movedItem);

      if (result.source.droppableId === "words") {
        setWords(sourceItems);
        setOrderedWords(destinationItems);
      } else {
        setWords(destinationItems);
        setOrderedWords(sourceItems);
      }
    }
  };

  const reset = () => {
    setWords(
      initialWords.map((word, index) => ({
        id: `word-${index}`,
        content: word,
      }))
    );
    setOrderedWords([]);
  };

  useEffect(() => {
    if (orderedWords.length > 0) {
      const words = orderedWords.map((ele) => ele.content).join(" ");
      if (words == question.frase) {
        setAnswer(question.id + "-1");
      } else {
        setAnswer(question.id + "-0");
      }
    }
  }, [orderedWords]);

  return (
    <Grid container columns={{ xs: 4, md: 12 }}>
      <Grid item xs={12}>
        <Box sx={{ display: "flex", justifyContent: "space-around" }}>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Container sx={{ maxWidth: 600, padding: 3, marginTop: -9 }}>
              {/*<Typography variant="h6" align="center" gutterBottom>
                Ordena la frase arrastrando las palabras
              </Typography>*/}
              <Stack direction="row">
                <AudioPlayer
                  audioUrl={`${API_DOMAIN}/contents/cursos/${courseCode}/audios/${question.audio}`}
                  key={question.audio}
                />
              </Stack>

              <Box sx={{marginTop: -3 }}>
                {/*<Typography variant="subtitle1" align="center">
                      Zona de orden
            </Typography>*/}
                <DroppableZone id="orderedWords" items={orderedWords} />
              </Box>
              <Box >
                {showInCorrect ? (
                  <Typography variant="subtitle1" align="center" color={"primary"} sx={{ fontWeight: "bold" }}>
                        {question.frase}
                  </Typography>
                ):null}
                <DroppableZone id="words" items={words} />
                <Button
                  onClick={reset}
                  sx={{ marginBottom: 0.2 }}
                  variant="contained"
                  color="primary"
                >
                  Borrar
                </Button>
              </Box>
            </Container>
          </DragDropContext>
        </Box>
      </Grid>
    </Grid>
  );
};

export default DragAndDropSentence;
